import { Box, Button, IconButton, Typography } from '@mui/material'
import { Dismiss24Regular } from '@/components/Icon'

/** Presentational soft-update notice (Refresh + dismiss). */
export default function AppUpdateBannerView({ onRefresh, onDismiss }) {
  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        minHeight: 44,
        px: 1.5,
        py: 0.75,
        borderRadius: '12px',
        bgcolor: 'background.paper',
        color: 'text.primary',
        border: 1,
        borderColor: 'divider',
        boxShadow: 3,
        maxWidth: 440,
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 510, lineHeight: '18px', flex: 1, pr: 0.5 }}>
        New version available
      </Typography>
      <Button size="small" variant="contained" onClick={onRefresh} sx={{ textTransform: 'none' }}>
        Refresh
      </Button>
      <IconButton size="small" aria-label="Dismiss update notice" onClick={onDismiss}>
        <Dismiss24Regular style={{ width: 16, height: 16 }} />
      </IconButton>
    </Box>
  )
}
